import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgIsInf } from '../../fg-math.js';

const isInfinityDef = {
  type: FgBlockType.IsInfinity,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any)],
    dataOut: [sockOut("value", FgType.Boolean)]
  }),
  updateOutputs(block, ctx, env) {
    const a = getDataValue(ctx, env, block, "a");
    setDataValue(ctx, block, "value", fgIsInf(a));
  }
};

export { isInfinityDef };
//# sourceMappingURL=is-infinity.js.map
